export default "__VITE_ASSET__gjlmX3ar__"